import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import Header from "../landingPage/Header";

const AccessibilityStatement = () => {
  return (
    <div>
      <Header />
      <div className="content-wrapper">
        <div className="essentials-support-row mt-4">
          <div className="text-center">
            <h2 className="red-pastel mb-4">Accessibility Statement</h2>
          </div>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={3}>
            1. Commitment to Accessibility
          </Typography>
          <Typography pt={2}>
            Conscisys is committed to ensuring digital accessibility for all users, including individuals with disabilities. We strive to provide inclusive, user-friendly, and equitable access to our websites, applications, and software solutions for courts, government agencies, and the public.
          </Typography>
          <Typography pt={2}>
            Accessibility is an integral part of our mission to deliver modern, secure, and scalable technology solutions for the justice system.
          </Typography>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={4}>
            2. Standards and Guidelines
          </Typography>
          <Typography pt={2}>
            We are actively working to align our digital properties and applications with:
          </Typography>
          <Box>
            <List component="nav">
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Web Content Accessibility Guidelines (WCAG) 2.1, Level AA
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Applicable provisions of the Americans with Disabilities Act (ADA)
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Section 508 of the Rehabilitation Act (as applicable)
                </Typography>
              </ListItem>
            </List>
          </Box>
          <Typography pt={2}>
            For government clients, we also support alignment with applicable state accessibility requirements, including the Illinois Information Technology Accessibility Act (IITAA), where relevant.
          </Typography>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={4}>
            3. Scope of Coverage
          </Typography>
          <Typography pt={2}>
            This accessibility statement applies to:
          </Typography>
          <Box>
            <List component="nav">
              <ListItem sx={{ alignItems: "flex-start" }}>
                <ListItemIcon sx={{ minWidth: "40px", mt: 0.5 }}>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Conscisys public website (including test and production environments)
                </Typography>
              </ListItem>
              <ListItem sx={{ alignItems: "flex-start" }}>
                <ListItemIcon sx={{ minWidth: "40px", mt: 0.5 }}>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Box sx={{ flex: 1 }}>
                  <Typography>
                    SaaS applications developed and maintained by Conscisys, including:
                  </Typography>
                  <List component="nav" sx={{ pl: 0, pt: 1 }}>
                    <ListItem sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: "40px" }}>
                        <ArrowForwardIcon color="action" fontSize="small" />
                      </ListItemIcon>
                      <Typography>eAppeal</Typography>
                    </ListItem>
                    <ListItem sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: "40px" }}>
                        <ArrowForwardIcon color="action" fontSize="small" />
                      </ListItemIcon>
                      <Typography>Illinois Uniform Citation System (IUCS)</Typography>
                    </ListItem>
                    <ListItem sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: "40px" }}>
                        <ArrowForwardIcon color="action" fontSize="small" />
                      </ListItemIcon>
                      <Typography>Order of Protection (OOP) systems</Typography>
                    </ListItem>
                    <ListItem sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: "40px" }}>
                        <ArrowForwardIcon color="action" fontSize="small" />
                      </ListItemIcon>
                      <Typography>i2File and related e-filing platforms</Typography>
                    </ListItem>
                  </List>
                </Box>
              </ListItem>
            </List>
          </Box>
          <Typography pt={2}>
            Accessibility of third-party integrations may vary; however, we work with partners and vendors to promote accessible solutions wherever feasible.
          </Typography>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={4}>
            4. Accessibility Features
          </Typography>
          <Typography pt={2}>
            Our accessibility efforts include:
          </Typography>
          <Box>
            <List component="nav">
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Use of semantic HTML and structured content for assistive technologies
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Keyboard-accessible navigation and workflows
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Descriptive link text and properly labeled form elements
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Focus management and visible focus indicators
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Ongoing improvements to color contrast and visual clarity
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Accessibility considerations in product design and development
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Regular automated and manual accessibility testing
                </Typography>
              </ListItem>
            </List>
          </Box>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={4}>
            5. Ongoing Improvements
          </Typography>
          <Typography pt={2}>
            We recognize that accessibility is an ongoing process. Conscisys continuously evaluates and enhances its systems to improve usability and accessibility across all platforms.
          </Typography>
          <Typography pt={2}>
            Areas of ongoing work may include:
          </Typography>
          <Box>
            <List component="nav">
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Enhancing complex workflows such as e-filing and multi-step forms
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Improving accessibility of legacy content and documents
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Strengthening compatibility with assistive technologies
                </Typography>
              </ListItem>
            </List>
          </Box>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={4}>
            6. Feedback and Support
          </Typography>
          <Typography pt={2}>
            We welcome feedback regarding accessibility. If you encounter any barriers while using our website or applications, please contact us:
          </Typography>
          <Typography pt={2} fontWeight="bold">
            Conscisys
          </Typography>
          <Typography>
            Email: support@conscisys.com
          </Typography>
          <Typography pt={2}>
            Please include:
          </Typography>
          <Box>
            <List component="nav">
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  The page or application you were using
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  A description of the issue
                </Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ArrowForwardIcon color="action" />
                </ListItemIcon>
                <Typography>
                  Any assistive technology used (if applicable)
                </Typography>
              </ListItem>
            </List>
          </Box>
          <Typography pt={2}>
            We will make reasonable efforts to respond promptly and provide assistance or alternative access.
          </Typography>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={4}>
            7. Accessibility for Government Clients
          </Typography>
          <Typography pt={2}>
            Conscisys partners with courts and government agencies to support accessibility compliance efforts. Our solutions are designed to help clients meet applicable accessibility requirements; however, final compliance may depend on configuration, content, and third-party integrations.
          </Typography>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={4}>
            8. Legal Disclaimer
          </Typography>
          <Typography pt={2}>
            While Conscisys strives to meet applicable accessibility standards, we do not warrant that all content or systems are fully compliant at all times. Accessibility improvements are ongoing, and we are committed to addressing identified issues in a timely manner.
          </Typography>

          <Typography variant="h5" color="#0f336d" fontWeight="bold" pt={4}>
            9. Ongoing Commitment
          </Typography>
          <Typography pt={2}>
            Conscisys remains dedicated to improving accessibility and ensuring that our technology solutions are usable by all individuals, including those with disabilities.
          </Typography>

          <Typography pt={4} pb={4} fontWeight="bold">
            Last Updated: April 2026
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityStatement;
